import { AtualizarExpedienteRastreavel } from './atualizarExpedienteRastreavel';
import { DeletarExpedienteRastreavel } from './deletarExpedienteRastreavel';
import { ObterExpedientesRastreavel } from './obterExpedientesRastreavel';
import { CriarExpedienteRastreavel } from './criarExpedienteRastreavel';

(new AtualizarExpedienteRastreavel()).executar();
(new DeletarExpedienteRastreavel()).executar();
(new ObterExpedientesRastreavel()).executar();
(new CriarExpedienteRastreavel()).executar();
